import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  selectSubscription: {
    marginTop: theme.spacing(1.5),
  },
  containerwrapper: {
    width: '100%',
  },
  rowContainer: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
  },
  middleRowContainer: {
    border: `1px solid ${theme.palette.dividerV2.main}`,
    borderWidth: '0px 1px 0px 1px',
  },
  oddColumn: {
    borderRight: `1px solid ${theme.palette.dividerV2.main}`,
  },
  selectanotherSubscription: {
    marginTop: theme.spacing(3),
  },
}))
